import RegisterBox from './RegisterBox';
export default RegisterBox;